// extracted by mini-css-extract-plugin
export default {"modal":"ConfirmDialog_modal__eXA-h","slide-down":"ConfirmDialog_slide-down__f7Z20"};